import { CustomerData } from 'app/types/backend-api'
import { Contact, Opportunity, SavedOffer } from 'app/types/types'
import { utc } from 'moment'
import { fetchNewData } from './data'
import { getOpportunitiesAndContacts } from 'app/services/client/client-api'
import { checkForSAPOIInprogress } from 'app/app/(client)/utils/utils'
import { setUnsavedOfferCount } from '../currentOffer/unsaved-offer-slice'
import { unsavedOffersCount } from 'app/app/(client)/nemo/offer'
import { setCustomerDataError, updateCustomerState } from './customer-slice'
import { fetchInitialAccountData, initializeCustomerOfferInStores, mergeLocalWithServerOffers } from './customers-async'
import { setAppInitialized } from '../init/app-initialized-slice'
import { AsyncThunkAPI, wrapCreateAsyncThunk } from 'app/app/(client)/utils/async-handler'

export type OpportunitiesAndContacts = {
  opportunities: { id: string; opportunities: Opportunity[] }[]
  contacts: { id: string; contacts: Contact[] }[]
  savedOffers: SavedOffer[]
}

const getCustomerOpportunitiesAsync = async (_?: any, thunkAPI?: AsyncThunkAPI) => {
  if (!thunkAPI) {
    throw new Error('ThunkAPI is not available')
  }
  const { dispatch, getState } = thunkAPI
  const opportunitiesAndContacts = await getOpportunitiesAndContacts()
  if (!opportunitiesAndContacts) {
    return
  }
  const { opportunities, contacts, savedOffers } = opportunitiesAndContacts
  const {
    customers: { data: customersObject }
  } = getState()
  const customers = customersObject?.customers || []
  const mergedCustomers = customers.map(customer => ({
    ...customer,
    contacts: contacts.filter(contact => contact.id === customer.id)[0]?.contacts || [],
    opportunities: opportunities.filter(opportunity => opportunity.id === customer.id)[0]?.opportunities || []
  }))
  const updatedData = {
    customers: mergedCustomers,
    offers: savedOffers
  }
  fetchInitialAccountData(updatedData)
    .then(mergeLocalWithServerOffers)
    .then(data => initializeCustomerOfferInStores(data as CustomerData, dispatch))
    .then(async updatedCustomerData => {
      dispatch(setUnsavedOfferCount(unsavedOffersCount(updatedCustomerData.offers || [])))
      fetchNewData(getState, dispatch)
      checkForSAPOIInprogress()
      dispatch(updateCustomerState(updatedCustomerData))
      console.log('Customer and Offer data initialization completed at ', utc().toISOString())
      dispatch(setAppInitialized(true))
    })
    .catch(err => Promise.reject(new Error(`Data initialization failed: ${err && err.message}`)))
}

export const getCustomerOpportunities = wrapCreateAsyncThunk<void, void>(
  'customers/mergeCustomersOpportunities',
  getCustomerOpportunitiesAsync,
  (error, dispatch) =>
    dispatch(setCustomerDataError({ message: error.message, code: error.status ?? error.type, stack: error.stack })),
  false // LoadingPage already surfaces this error, so skip the generic alert popup
)
